import { makeStyles, Theme, } from '@material-ui/core/styles';

export const makeChipClasses = makeStyles((theme: Theme) => ({
    root: {
        margin: theme.spacing(1, 1, 0, 0),
    },
}));
